module.exports = __webpack_public_path__ + "media/images/cus_2-9a20358cff4abbf6ef132e4132f29320.png";